import { useState } from "react";
import QuoteActions from "./QuoteActions";
import QuoteAvailability from "./QuoteAvailability";

const nottiList = [5,6,7,8,9,10,11,12,13,14,15];

const _prezziOriginali = {
  alta: { adulto: [1050,1210,1350,1440,1540,1630,1730,1820,1910,2010,2100] },
  bassa_con: { adulto: [1000,1160,1300,1390,1490,1580,1680,1770,1860,1960,2050] },
  bassa_senza: { adulto: [770,850,940,1030,1120,1200,1290,1380,1460,1550,1640] },
  bambini: {
    b2_4: [230,260,300,330,370,400,440,470,510,540,580],
    b5_12: [700,770,840,860,880,900,920,940,960,980,1000],
  }
};

export const LINK_ORIGINALI = { GOOGLE: "https://tinyurl.com/BluLodge-Google",
  TRIP: "https://tinyurl.com/BluLodge-TripAdvisor" };
const _socialOriginali = {
  blufb:   "https://www.facebook.com/blulodgemaldives/",
  bluig:   "https://www.instagram.com/blulodge_maldives/",
  blusito: "https://www.blulodgemaldives.com",
  a20fb:   "https://www.facebook.com/AfterTwentyTravel/",
  a20ig:   "https://www.instagram.com/a20travel/",
  a20sito: "https://a20-travel.com",
};

const _pdfOriginali = {
  full: "https://www.blulodgemaldives.com/Blu_Lodge_BLU_X-Perience_FULL.pdf",
  flex: "https://www.blulodgemaldives.com/Blu_Lodge_BLU_X-Perience_FLEX.pdf",
};

// Supplemento celiachia / allergie / intolleranze alimentari (a persona, per soggiorno)
export const LISTINO_ORIGINALE = { prezzi: _prezziOriginali, social: _socialOriginali, pdf: _pdfOriginali, dieta: 50 };

const BRAND = "Blu Lodge Maldives - la tua casa lontano da casa - isola di Keyodhoo - Atollo di Vaavu";

// --- Gestione periodo ---
// Mesi: 0=Gennaio ... 11=Dicembre.
// Chiusura struttura: dal 10 MAGGIO al 30 GIUGNO compresi (prenotabile solo con forzatura, listino BASSA).
// 1–9 maggio: sempre vendibile, listino ALTA (coda della stagione Novembre–Aprile).
// Alta stagione: Novembre–Aprile — Bassa stagione: Luglio–Ottobre.
const inChiusura = (d) => {
  const m = d.getMonth(), g = d.getDate();
  return (m === 4 && g >= 10) || m === 5;
};
const stagioneDaData = (d) => {
  const m = d.getMonth(), g = d.getDate();
  if (m >= 6 && m <= 9) return "bassa";           // luglio–ottobre
  if (m === 4) return g <= 9 ? "alta" : "bassa";  // 1–9 maggio alta, dal 10 chiusura → bassa
  if (m === 5) return "bassa";                    // giugno chiusura → bassa
  return "alta";                                  // novembre–aprile
};
const stagioneDaMese = (m) => ((m >= 6 && m <= 9) || m === 4 || m === 5) ? "bassa" : "alta";
const MESI_STANDARD = [0,1,2,3,6,7,8,9,10,11];
const MESI_CHIUSURA = [4,5];

const LOCALES = { it:"it-IT", en:"en-GB", de:"de-DE", fr:"fr-FR", nl:"nl-NL", da:"da-DK" };
const nomeMese = (m, lingua) => {
  const nm = new Intl.DateTimeFormat(LOCALES[lingua] || "it-IT", { month:"long" }).format(new Date(2026, m, 1));
  return nm.charAt(0).toUpperCase() + nm.slice(1);
};
const fmtData = (iso, lingua) => new Date(iso + "T12:00:00").toLocaleDateString(LOCALES[lingua] || "it-IT");

// --- Conversione data per il campo testo di fallback (modalità PC su tablet) ---
const isoToTxt = (iso) => {
  if (!iso) return "";
  const [a, m, g] = iso.split("-");
  return `${g}/${m}/${a}`;
};
const txtToIso = (txt) => {
  const m = txt.trim().match(/^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{4})$/);
  if (!m) return null;
  const g = Number(m[1]), me = Number(m[2]), a = Number(m[3]);
  const d = new Date(a, me - 1, g);
  if (d.getFullYear() !== a || d.getMonth() !== me - 1 || d.getDate() !== g) return null;
  return `${a}-${String(me).padStart(2, "0")}-${String(g).padStart(2, "0")}`;
};

const traduzioni = {
  it: {
    flag:"🇮🇹", label:"Italiano",
    saluto: n => `Ciao ${n}! 🌊`,
    proposta: p => `Ecco la proposta *${BRAND}* — ${p}:`,
    adulti:"Adulti", singola:"camera doppia uso singola", totale:"Totale",
    bimbi02:"Bambini 0-1,99 anni", bimbi24:"Bambini 2-4,99 anni", bimbi512:"Bambini 5-12,99 anni",
    gratuito:"GRATUITO", totaleComplessivo:"TOTALE COMPLESSIVO",
    giorni:"giorni", notti:"notti",
    voliEsclusi:"*voli esclusi*",
    scontoRiga:"🎁 *Sconto dedicato a te:*",
    totaleScontato:"✨ *TOTALE SCONTATO*",
    confrontoTitolo:"💡 *Le due formule a confronto:*",
    optAbreve:"✅🤿 Opzione A — escursioni incluse",
    optBbreve:"🏖️ Opzione B — escursioni in loco",
    conSconto:"scontato",
    natale:"🎄 Cena di Natale inclusa",
    capodanno:"🎆 Cenone di Capodanno con festa in spiaggia incluso",
    avvisoEsclusi:"⚠️ *Non inclusi nel prezzo:*",
    esclusoNatale:"cena di Natale",
    esclusoCapodanno:"cenone di Capodanno con festa in spiaggia",
    incluso:"✅ *Incluso nel pacchetto:*",
    inclusoDoppio:"✅ *Inclusi in entrambi i pacchetti:*",
    servizi:[
      "Accoglienza Airport counter",
      "Trasferimenti in barca veloce",
      "Pensione completa (softdrinks ai pasti, in escursione e acqua nel frigo bar)",
      "Unico ristorante fronte oceano dell'isola, due cuochi dedicati: uno al ristorante e uno che vi segue in escursione",
      "Manager italiano presente per almeno 8 mesi l'anno, staff che parla italiano e inglese",
      "Tasse",
      "Pulizia camera 2 volte al giorno come nei migliori resort",
      "Cena sulla spiaggia",
      "Serata maldiviana",
      "n.01 ombrellone e n.02 lettini per camera in escursione",
    ],
    pdfIntro:"📄 *Scopri i dettagli del pacchetto:*",
    pdfCompleto:"📄 BLU X-Perience Completo",
    pdfFlessibile:"📄 BLU X-Perience Flessibile",
    recensioni:"📖 Leggi cosa dicono i nostri ospiti:",
    voli:"✈️ Per i *voli* possiamo supportarti tramite le nostre agenzie partner o guidarti nella prenotazione autonoma — basta chiedere!",
    chiudi:"Sono qui per qualsiasi domanda, scrivimi quando vuoi 🌴",
    optA:"✅🤿 *OPZIONE A — Escursioni incluse nel pacchetto*",
    optB:"🏖️ *OPZIONE B — Escursioni non incluse nel pacchetto ma acquistabili in loco*",
    escAltaCorte:"✅ Escursioni incluse nel pacchetto 🤿",
    escAltaLunga:"✅ 6 escursioni incluse nel pacchetto, le altre acquistabili in loco 🤿",
    escBassaConCorte:"✅ Escursioni incluse nel pacchetto 🤿",
    escBassaConLunga:"✅ 6 escursioni incluse nel pacchetto, le altre acquistabili in loco 🤿",
    escBassaSenza:"🏖️ Costo escursioni per persona: Full Day 80€/cad, Half Day 40€/cad (bambini < 13 anni FOC)",
    seguici:"🌍 *Seguici e metti like, ci trovi qui:*",
    socialBluFb:"📘 Blu Lodge Facebook",
    socialBluIg:"📸 Blu Lodge Instagram",
    socialBluSito:"🌐 Blu Lodge Maldives — Sito",
    socialA20Fb:"📘 A20 Travel Facebook",
    socialA20Ig:"📸 A20 Travel Instagram",
    socialA20Sito:"🌐 A20 Travel — Sito",
    periodi:{ alta:"Novembre – Aprile", bassa:"Luglio – Ottobre" },
    dalAl:(a,b)=>`dal ${a} al ${b}`,
    dieta:"Menu senza glutine / allergie e intolleranze",
    notaDieta:"🌾 *Celiachia, allergie e intolleranze alimentari:* prepariamo i pasti con la massima attenzione alla non contaminazione e utilizziamo prodotti senza glutine, anche importati dall'Italia.",
  },
  en: {
    flag:"🇬🇧", label:"English",
    saluto: n => `Hi ${n}! 🌊`,
    proposta: p => `Here is the *${BRAND}* proposal — ${p}:`,
    adulti:"Adults", singola:"double room single use", totale:"Total",
    bimbi02:"Children 0-1.99 yrs", bimbi24:"Children 2-4.99 yrs", bimbi512:"Children 5-12.99 yrs",
    gratuito:"FREE OF CHARGE", totaleComplessivo:"TOTAL",
    giorni:"days", notti:"nights",
    voliEsclusi:"*flights not included*",
    scontoRiga:"🎁 *Special discount for you:*",
    totaleScontato:"✨ *DISCOUNTED TOTAL*",
    confrontoTitolo:"💡 *The two formulas compared:*",
    optAbreve:"✅🤿 Option A — excursions included",
    optBbreve:"🏖️ Option B — excursions on-site",
    conSconto:"discounted",
    natale:"🎄 Christmas dinner included",
    capodanno:"🎆 New Year's Eve beach party dinner included",
    avvisoEsclusi:"⚠️ *Not included in the price:*",
    esclusoNatale:"Christmas dinner",
    esclusoCapodanno:"New Year's Eve beach party dinner",
    incluso:"✅ *Included in the package:*",
    inclusoDoppio:"✅ *Included in both packages:*",
    servizi:[
      "Airport counter welcome",
      "Speedboat transfers",
      "Full board (soft drinks with meals, during excursions and water in the minibar)",
      "The island's only oceanfront restaurant, two dedicated chefs: one at the restaurant and one who joins you on excursions",
      "Italian manager on site at least 8 months a year, Italian- and English-speaking staff",
      "Taxes",
      "Room cleaning twice a day, like in the best resorts",
      "Beach dinner",
      "Maldivian night",
      "x1 beach umbrella and x2 sun loungers per room during excursions",
    ],
    pdfIntro:"📄 *Discover the package details:*",
    pdfCompleto:"📄 BLU X-Perience Complete",
    pdfFlessibile:"📄 BLU X-Perience Flexible",
    recensioni:"📖 Read what our guests say:",
    voli:"✈️ For *flights* we can assist you through our partner agencies or guide you to book independently — just ask!",
    chiudi:"I'm here for any questions, feel free to write anytime 🌴",
    optA:"✅🤿 *OPTION A — Excursions included in the package*",
    optB:"🏖️ *OPTION B — Excursions not included but available on-site*",
    escAltaCorte:"✅ Excursions included in the package 🤿",
    escAltaLunga:"✅ 6 excursions included, others available on-site 🤿",
    escBassaConCorte:"✅ Excursions included in the package 🤿",
    escBassaConLunga:"✅ 6 excursions included, others available on-site 🤿",
    escBassaSenza:"🏖️ Excursion cost per person: Full Day 80€/pp, Half Day 40€/pp (children < 13 yrs FOC)",
    seguici:"🌍 *Follow us and leave a like:*",
    socialBluFb:"📘 Blu Lodge Facebook",
    socialBluIg:"📸 Blu Lodge Instagram",
    socialBluSito:"🌐 Blu Lodge Maldives — Website",
    socialA20Fb:"📘 A20 Travel Facebook",
    socialA20Ig:"📸 A20 Travel Instagram",
    socialA20Sito:"🌐 A20 Travel — Website",
    periodi:{ alta:"November – April", bassa:"July – October" },
    dalAl:(a,b)=>`from ${a} to ${b}`,
    dieta:"Gluten-free / allergy & intolerance menu",
    notaDieta:"🌾 *Coeliac disease, food allergies and intolerances:* meals are prepared with strict cross-contamination control, using gluten-free products, some imported from Italy.",
  },
  de: {
    flag:"🇩🇪", label:"Deutsch",
    saluto: n => `Hallo ${n}! 🌊`,
    proposta: p => `Hier ist unser *${BRAND}* Angebot — ${p}:`,
    adulti:"Erwachsene", singola:"Doppelzimmer Einzelnutzung", totale:"Gesamt",
    bimbi02:"Kinder 0-1,99 J.", bimbi24:"Kinder 2-4,99 J.", bimbi512:"Kinder 5-12,99 J.",
    gratuito:"KOSTENLOS", totaleComplessivo:"GESAMTBETRAG",
    giorni:"Tage", notti:"Nächte",
    voliEsclusi:"*Flüge nicht inbegriffen*",
    scontoRiga:"🎁 *Ihr persönlicher Rabatt:*",
    totaleScontato:"✨ *RABATTIERTER GESAMTBETRAG*",
    confrontoTitolo:"💡 *Die beiden Formeln im Vergleich:*",
    optAbreve:"✅🤿 Option A — Ausflüge inklusive",
    optBbreve:"🏖️ Option B — Ausflüge vor Ort",
    conSconto:"rabattiert",
    natale:"🎄 Weihnachtsdinner inbegriffen",
    capodanno:"🎆 Silvester-Strandparty inbegriffen",
    avvisoEsclusi:"⚠️ *Nicht im Preis enthalten:*",
    esclusoNatale:"Weihnachtsdinner",
    esclusoCapodanno:"Silvester-Strandparty",
    incluso:"✅ *Im Paket enthalten:*",
    inclusoDoppio:"✅ *In beiden Paketen enthalten:*",
    servizi:[
      "Empfang am Flughafen",
      "Schnellboot-Transfer",
      "Vollpension (Softdrinks zu den Mahlzeiten, bei Ausflügen und Wasser in der Minibar)",
      "Das einzige Restaurant der Insel direkt am Meer, zwei eigene Köche: einer im Restaurant, einer begleitet Sie auf den Ausflügen",
      "Italienischer Manager mindestens 8 Monate im Jahr vor Ort, italienisch- und englischsprachiges Personal",
      "Steuern",
      "Zimmerreinigung 2x täglich wie in den besten Resorts",
      "Strandabendessen",
      "Maledivischer Abend",
      "1x Sonnenschirm und 2x Liegestühle pro Zimmer bei Ausflügen",
    ],
    pdfIntro:"📄 *Alle Details zum Paket:*",
    pdfCompleto:"📄 BLU X-Perience Komplett",
    pdfFlessibile:"📄 BLU X-Perience Flexibel",
    recensioni:"📖 Lesen Sie, was unsere Gäste sagen:",
    voli:"✈️ Bei *Flügen* können wir Ihnen über unsere Partneragenturen helfen — fragen Sie einfach!",
    chiudi:"Ich bin jederzeit für Fragen erreichbar 🌴",
    optA:"✅🤿 *OPTION A — Ausflüge im Paket enthalten*",
    optB:"🏖️ *OPTION B — Ausflüge nicht enthalten, aber vor Ort buchbar*",
    escAltaCorte:"✅ Ausflüge im Paket enthalten 🤿",
    escAltaLunga:"✅ 6 Ausflüge enthalten, weitere vor Ort buchbar 🤿",
    escBassaConCorte:"✅ Ausflüge im Paket enthalten 🤿",
    escBassaConLunga:"✅ 6 Ausflüge enthalten, weitere vor Ort buchbar 🤿",
    escBassaSenza:"🏖️ Ausflugkosten pro Person: Full Day 80€/Person, Half Day 40€/Person (Kinder < 13 J. kostenlos)",
    seguici:"🌍 *Folge uns und gib uns ein Like:*",
    socialBluFb:"📘 Blu Lodge Facebook",
    socialBluIg:"📸 Blu Lodge Instagram",
    socialBluSito:"🌐 Blu Lodge Maldives — Webseite",
    socialA20Fb:"📘 A20 Travel Facebook",
    socialA20Ig:"📸 A20 Travel Instagram",
    socialA20Sito:"🌐 A20 Travel — Webseite",
    periodi:{ alta:"November – April", bassa:"Juli – Oktober" },
    dalAl:(a,b)=>`vom ${a} bis ${b}`,
    dieta:"Glutenfreies Menü / Allergien & Unverträglichkeiten",
    notaDieta:"🌾 *Zöliakie, Lebensmittelallergien und -unverträglichkeiten:* Wir bereiten die Mahlzeiten mit größter Sorgfalt gegen Kreuzkontamination zu und verwenden glutenfreie Produkte, teils aus Italien importiert.",
  },
  fr: {
    flag:"🇫🇷", label:"Français",
    saluto: n => `Bonjour ${n}! 🌊`,
    proposta: p => `Voici notre proposition *${BRAND}* — ${p}:`,
    adulti:"Adultes", singola:"chambre double usage individuel", totale:"Total",
    bimbi02:"Enfants 0-1,99 ans", bimbi24:"Enfants 2-4,99 ans", bimbi512:"Enfants 5-12,99 ans",
    gratuito:"GRATUIT", totaleComplessivo:"TOTAL GÉNÉRAL",
    giorni:"jours", notti:"nuits",
    voliEsclusi:"*vols non inclus*",
    scontoRiga:"🎁 *Remise qui vous est réservée:*",
    totaleScontato:"✨ *TOTAL REMISÉ*",
    confrontoTitolo:"💡 *Les deux formules comparées:*",
    optAbreve:"✅🤿 Option A — excursions incluses",
    optBbreve:"🏖️ Option B — excursions sur place",
    conSconto:"remisé",
    natale:"🎄 Dîner de Noël inclus",
    capodanno:"🎆 Réveillon du Nouvel An sur la plage inclus",
    avvisoEsclusi:"⚠️ *Non inclus dans le prix:*",
    esclusoNatale:"dîner de Noël",
    esclusoCapodanno:"réveillon du Nouvel An sur la plage",
    incluso:"✅ *Inclus dans le forfait:*",
    inclusoDoppio:"✅ *Inclus dans les deux forfaits:*",
    servizi:[
      "Accueil au comptoir de l'aéroport",
      "Transferts en bateau rapide",
      "Pension complète (softs aux repas, en excursion et eau au minibar)",
      "Le seul restaurant face à l'océan de l'île, deux chefs dédiés : un au restaurant et un qui vous accompagne en excursion",
      "Manager italien présent au moins 8 mois par an, personnel parlant italien et anglais",
      "Taxes",
      "Nettoyage de la chambre 2 fois par jour comme dans les meilleurs resorts",
      "Dîner sur la plage",
      "Soirée maldivienne",
      "x1 parasol et x2 transats par chambre en excursion",
    ],
    pdfIntro:"📄 *Découvrez les détails du forfait:*",
    pdfCompleto:"📄 BLU X-Perience Complet",
    pdfFlessibile:"📄 BLU X-Perience Flexible",
    recensioni:"📖 Lisez les avis de nos clients:",
    voli:"✈️ Pour les *vols*, nous pouvons vous aider via nos agences partenaires — demandez-nous!",
    chiudi:"Je suis disponible pour toute question, écrivez-moi quand vous voulez 🌴",
    optA:"✅🤿 *OPTION A — Excursions incluses dans le forfait*",
    optB:"🏖️ *OPTION B — Excursions non incluses mais disponibles sur place*",
    escAltaCorte:"✅ Excursions incluses dans le forfait 🤿",
    escAltaLunga:"✅ 6 excursions incluses, autres disponibles sur place 🤿",
    escBassaConCorte:"✅ Excursions incluses dans le forfait 🤿",
    escBassaConLunga:"✅ 6 excursions incluses, autres disponibles sur place 🤿",
    escBassaSenza:"🏖️ Coût des excursions par personne: Full Day 80€/pers, Half Day 40€/pers (enfants < 13 ans gratuit)",
    seguici:"🌍 *Suivez-nous et mettez un like:*",
    socialBluFb:"📘 Blu Lodge Facebook",
    socialBluIg:"📸 Blu Lodge Instagram",
    socialBluSito:"🌐 Blu Lodge Maldives — Site web",
    socialA20Fb:"📘 A20 Travel Facebook",
    socialA20Ig:"📸 A20 Travel Instagram",
    socialA20Sito:"🌐 A20 Travel — Site web",
    periodi:{ alta:"Novembre – Avril", bassa:"Juillet – Octobre" },
    dalAl:(a,b)=>`du ${a} au ${b}`,
    dieta:"Menu sans gluten / allergies et intolérances",
    notaDieta:"🌾 *Maladie cœliaque, allergies et intolérances alimentaires :* nous préparons les repas en évitant toute contamination croisée et utilisons des produits sans gluten, dont certains importés d'Italie.",
  },
  nl: {
    flag:"🇳🇱", label:"Nederlands",
    saluto: n => `Hallo ${n}! 🌊`,
    proposta: p => `Hier is ons *${BRAND}* voorstel — ${p}:`,
    adulti:"Volwassenen", singola:"tweepersoonskamer enkelbezetting", totale:"Totaal",
    bimbi02:"Kinderen 0-1,99 jr", bimbi24:"Kinderen 2-4,99 jr", bimbi512:"Kinderen 5-12,99 jr",
    gratuito:"GRATIS", totaleComplessivo:"TOTAALBEDRAG",
    giorni:"dagen", notti:"nachten",
    voliEsclusi:"*vluchten niet inbegrepen*",
    scontoRiga:"🎁 *Speciale korting voor jou:*",
    totaleScontato:"✨ *TOTAAL MET KORTING*",
    confrontoTitolo:"💡 *De twee formules vergeleken:*",
    optAbreve:"✅🤿 Optie A — excursies inbegrepen",
    optBbreve:"🏖️ Optie B — excursies ter plaatse",
    conSconto:"met korting",
    natale:"🎄 Kerstdiner inbegrepen",
    capodanno:"🎆 Oud & Nieuw strandfeest inbegrepen",
    avvisoEsclusi:"⚠️ *Niet inbegrepen in de prijs:*",
    esclusoNatale:"kerstdiner",
    esclusoCapodanno:"oud & nieuw strandfeest",
    incluso:"✅ *Inbegrepen in het pakket:*",
    inclusoDoppio:"✅ *Inbegrepen in beide pakketten:*",
    servizi:[
      "Ontvangst op de luchthaven",
      "Speedboottransfers",
      "Vol pension (frisdranken bij maaltijden, tijdens excursies en water in de minibar)",
      "Het enige restaurant aan de oceaan van het eiland, twee eigen koks: één in het restaurant en één die met u mee gaat op excursie",
      "Italiaanse manager minstens 8 maanden per jaar aanwezig, Italiaans- en Engelssprekend personeel",
      "Belastingen",
      "Kamerreiniging 2x per dag zoals in de beste resorts",
      "Stranddiner",
      "Maldivische avond",
      "1x parasol en 2x ligstoelen per kamer tijdens excursies",
    ],
    pdfIntro:"📄 *Ontdek de details van het pakket:*",
    pdfCompleto:"📄 BLU X-Perience Compleet",
    pdfFlessibile:"📄 BLU X-Perience Flexibel",
    recensioni:"📖 Lees wat onze gasten zeggen:",
    voli:"✈️ Voor *vluchten* kunnen wij u helpen via onze partneragentschappen — vraag het gewoon!",
    chiudi:"Ik sta altijd klaar voor vragen, schrijf me wanneer je wilt 🌴",
    optA:"✅🤿 *OPTIE A — Excursies inbegrepen in het pakket*",
    optB:"🏖️ *OPTIE B — Excursies niet inbegrepen maar ter plaatse beschikbaar*",
    escAltaCorte:"✅ Excursies inbegrepen in het pakket 🤿",
    escAltaLunga:"✅ 6 excursies inbegrepen, andere ter plaatse beschikbaar 🤿",
    escBassaConCorte:"✅ Excursies inbegrepen in het pakket 🤿",
    escBassaConLunga:"✅ 6 excursies inbegrepen, andere ter plaatse beschikbaar 🤿",
    escBassaSenza:"🏖️ Kosten excursies per persoon: Full Day 80€/pers, Half Day 40€/pers (kinderen < 13 jr gratis)",
    seguici:"🌍 *Volg ons en geef een like:*",
    socialBluFb:"📘 Blu Lodge Facebook",
    socialBluIg:"📸 Blu Lodge Instagram",
    socialBluSito:"🌐 Blu Lodge Maldives — Website",
    socialA20Fb:"📘 A20 Travel Facebook",
    socialA20Ig:"📸 A20 Travel Instagram",
    socialA20Sito:"🌐 A20 Travel — Website",
    periodi:{ alta:"November – April", bassa:"Juli – Oktober" },
    dalAl:(a,b)=>`van ${a} tot ${b}`,
    dieta:"Glutenvrij menu / allergieën & intoleranties",
    notaDieta:"🌾 *Coeliakie, voedselallergieën en -intoleranties:* we bereiden de maaltijden met strikte controle op kruisbesmetting en gebruiken glutenvrije producten, deels geïmporteerd uit Italië.",
  },
  da: {
    flag:"🇩🇰", label:"Dansk",
    saluto: n => `Hej ${n}! 🌊`,
    proposta: p => `Her er vores *${BRAND}* tilbud — ${p}:`,
    adulti:"Voksne", singola:"dobbeltværelse enkeltbrug", totale:"Total",
    bimbi02:"Børn 0-1,99 år", bimbi24:"Børn 2-4,99 år", bimbi512:"Børn 5-12,99 år",
    gratuito:"GRATIS", totaleComplessivo:"SAMLET BELØB",
    giorni:"dage", notti:"nætter",
    voliEsclusi:"*fly ikke inkluderet*",
    scontoRiga:"🎁 *Særlig rabat til dig:*",
    totaleScontato:"✨ *TOTAL MED RABAT*",
    confrontoTitolo:"💡 *De to formler sammenlignet:*",
    optAbreve:"✅🤿 Mulighed A — udflugter inkluderet",
    optBbreve:"🏖️ Mulighed B — udflugter på stedet",
    conSconto:"med rabat",
    natale:"🎄 Julefrokost inkluderet",
    capodanno:"🎆 Nytårsfest på stranden inkluderet",
    avvisoEsclusi:"⚠️ *Ikke inkluderet i prisen:*",
    esclusoNatale:"julefrokost",
    esclusoCapodanno:"nytårsfest på stranden",
    incluso:"✅ *Inkluderet i pakken:*",
    inclusoDoppio:"✅ *Inkluderet i begge pakker:*",
    servizi:[
      "Velkomst i lufthavnen",
      "Speedbåd-transfer",
      "Helpension (sodavand til måltider, under udflugter og vand i minibaren)",
      "Øens eneste restaurant ud til havet, to dedikerede kokke: én i restauranten og én der følger jer på udflugter",
      "Italiensk manager til stede mindst 8 måneder om året, personale der taler italiensk og engelsk",
      "Skatter",
      "Rengøring af værelse 2x dagligt som på de bedste resorts",
      "Stranddinner",
      "Maldivisk aften",
      "1x parasol og 2x liggestole pr. værelse under udflugter",
    ],
    pdfIntro:"📄 *Se alle detaljer om pakken:*",
    pdfCompleto:"📄 BLU X-Perience Komplet",
    pdfFlessibile:"📄 BLU X-Perience Fleksibel",
    recensioni:"📖 Læs hvad vores gæster siger:",
    voli:"✈️ Til *fly* kan vi hjælpe dig via vores partneragenturer — spørg bare!",
    chiudi:"Jeg er tilgængelig for spørgsmål når som helst 🌴",
    optA:"✅🤿 *MULIGHED A — Udflugter inkluderet i pakken*",
    optB:"🏖️ *MULIGHED B — Udflugter ikke inkluderet men tilgængelige på stedet*",
    escAltaCorte:"✅ Udflugter inkluderet i pakken 🤿",
    escAltaLunga:"✅ 6 udflugter inkluderet, andre tilgængelige på stedet 🤿",
    escBassaConCorte:"✅ Udflugter inkluderet i pakken 🤿",
    escBassaConLunga:"✅ 6 udflugter inkluderet, andre tilgængelige på stedet 🤿",
    escBassaSenza:"🏖️ Pris på udflugter pr. person: Full Day 80€/pers, Half Day 40€/pers (børn < 13 år gratis)",
    seguici:"🌍 *Følg os og giv et like:*",
    socialBluFb:"📘 Blu Lodge Facebook",
    socialBluIg:"📸 Blu Lodge Instagram",
    socialBluSito:"🌐 Blu Lodge Maldives — Hjemmeside",
    socialA20Fb:"📘 A20 Travel Facebook",
    socialA20Ig:"📸 A20 Travel Instagram",
    socialA20Sito:"🌐 A20 Travel — Hjemmeside",
    periodi:{ alta:"November – April", bassa:"Juli – Oktober" },
    dalAl:(a,b)=>`fra ${a} til ${b}`,
    dieta:"Glutenfri menu / allergier & intolerancer",
    notaDieta:"🌾 *Cøliaki, fødevareallergier og -intolerancer:* vi tilbereder måltiderne med streng kontrol mod krydskontaminering og bruger glutenfri produkter, nogle importeret fra Italien.",
  },
};

export default function Calculator({ L, links }) {
  const prezzi = { alta: { adulto: L.alta }, bassa_con: { adulto: L.bassa_con }, bassa_senza: { adulto: L.bassa_senza }, bambini: { b2_4: L.b2_4, b5_12: L.b5_12 } };
  const GOOGLE = links.google, TRIP = links.trip;
  const SOCIAL = { blufb: links.blufb, bluig: links.bluig, blusito: links.blusito, a20fb: links.a20fb, a20ig: links.a20ig, a20sito: links.a20sito };
  const PDF = { full: links.pdf_full, flex: links.pdf_flex };
  const SUPPL_DIETA = L.dieta;
  const [lingua, setLingua]               = useState("it");
  const [modoPeriodo, setModoPeriodo]     = useState("stagione"); // "stagione" | "mese" | "date"
  const [periodo, setPeriodo]             = useState("");
  const [mese, setMese]                   = useState("");
  const [checkIn, setCheckIn]             = useState("");
  const [checkOut, setCheckOut]           = useState("");
  const [checkInTxt, setCheckInTxt]       = useState("");
  const [checkOutTxt, setCheckOutTxt]     = useState("");
  const [notti, setNotti]                 = useState(7);
  const [isSingle, setIsSingle]           = useState(false);
  const [adulti, setAdulti]               = useState(2);
  const [b02, setB02]                     = useState(0);
  const [b24, setB24]                     = useState(0);
  const [b512, setB512]                   = useState(0);
  const [natale, setNatale]               = useState(false);
  const [capodanno, setCapodanno]         = useState(false);
  const [nome, setNome]                   = useState("");
  const [copied, setCopied]               = useState(false);
  const [modalitaBassa, setModalitaBassa] = useState("entrambe");
  const [forzaChiusura, setForzaChiusura] = useState(false);
  const [dieta, setDieta]                 = useState(false);
  const [nDieta, setNDieta]               = useState(1);
  const [tipoSconto, setTipoSconto]       = useState("nessuno"); // "nessuno" | "euro" | "percento"
  const [valoreSconto, setValoreSconto]   = useState("");

  const t = traduzioni[lingua];

  const cambiaModo = (m) => {
    setModoPeriodo(m);
    setPeriodo(""); setMese(""); setCheckIn(""); setCheckOut("");
    setCheckInTxt(""); setCheckOutTxt("");
    setNatale(false); setCapodanno(false); setModalitaBassa("entrambe");
    setForzaChiusura(false);
  };

  // Applica il check-in da qualsiasi sorgente (calendario o testo) e sincronizza i campi
  const applyCheckIn = (iso) => {
    setCheckIn(iso);
    setCheckInTxt(isoToTxt(iso));
    if (iso && (!checkOut || checkOut <= iso)) {
      const d = new Date(iso + "T12:00:00");
      d.setDate(d.getDate() + 7);
      const out = d.toISOString().slice(0, 10);
      setCheckOut(out);
      setCheckOutTxt(isoToTxt(out));
    }
  };
  const applyCheckOut = (iso) => {
    setCheckOut(iso);
    setCheckOutTxt(isoToTxt(iso));
  };

  const cambiaForza = (val) => {
    setForzaChiusura(val);
    if (!val && (mese === "4" || mese === "5" || mese === 4 || mese === 5)) setMese("");
  };

  // --- Analisi modalità DATE: notti, stagione, festività automatiche, errori ---
  let dataErrore = null;        // "ordine" | "chiuso" | "durata"
  let nottiDate = null;
  let stagioneDate = null;
  let nataleAuto = false;
  let capodannoAuto = false;
  let toccaChiusura = false;
  let inPeriodoFestivo = false;

  if (modoPeriodo === "date" && checkIn && checkOut) {
    const dIn  = new Date(checkIn + "T12:00:00");
    const dOut = new Date(checkOut + "T12:00:00");
    const diff = Math.round((dOut - dIn) / 86400000);
    if (diff <= 0) {
      dataErrore = "ordine";
    } else {
      nottiDate = diff;
      for (let i = 0; i < diff; i++) {
        const d = new Date(dIn);
        d.setDate(dIn.getDate() + i);
        const m = d.getMonth();
        if (inChiusura(d)) {
          toccaChiusura = true;
          if (!forzaChiusura) dataErrore = "chiuso";
        }
        if (m === 11 && d.getDate() === 24) nataleAuto = true;
        if (m === 11 && d.getDate() === 31) capodannoAuto = true;
        if (m === 11 && d.getDate() >= 24) inPeriodoFestivo = true;
      }
      if (!dataErrore && (nottiDate < 5 || nottiDate > 15)) dataErrore = "durata";
      stagioneDate = stagioneDaData(dIn);
    }
  }

  const periodoEff =
    modoPeriodo === "stagione" ? periodo :
    modoPeriodo === "mese"     ? (mese !== "" && (forzaChiusura || !MESI_CHIUSURA.includes(Number(mese))) ? stagioneDaMese(Number(mese)) : "") :
    (checkIn && checkOut && !dataErrore ? stagioneDate || "" : "");

  const nottiEff     = (modoPeriodo === "date" && nottiDate && !dataErrore) ? nottiDate : notti;
  const nataleEff    = modoPeriodo === "date" ? nataleAuto    : natale;
  const capodannoEff = modoPeriodo === "date" ? capodannoAuto : capodanno;

  const festivitaRilevante =
    modoPeriodo === "date" ? inPeriodoFestivo :
    modoPeriodo === "mese" ? (Number(mese) === 11) :
    true;

  const idx    = nottiList.indexOf(nottiEff);
  const giorni = nottiEff + 1;

  const getPrezzoAdulto = (opt) => {
    if (!periodoEff || idx < 0) return 0;
    if (periodoEff === "alta") {
      const base = prezzi.alta.adulto[idx];
      return isSingle && adulti === 1 ? Math.round(base * (1 + L.singola_pct / 100) / 10) * 10 : base;
    }
    const key  = opt === "senza" ? "bassa_senza" : "bassa_con";
    const base = prezzi[key].adulto[idx];
    return isSingle && adulti === 1 ? Math.round(base * (1 + L.singola_pct / 100) / 10) * 10 : base;
  };

  const prezzoBimbi24  = idx >= 0 ? prezzi.bambini.b2_4[idx]  : 0;
  const prezzoBimbi512 = idx >= 0 ? prezzi.bambini.b5_12[idx] : 0;

  // --- Sconto ---
  const scontoNum = Number(String(valoreSconto).replace(",", ".")) || 0;
  const scontoAttivo = tipoSconto !== "nessuno" && scontoNum > 0;
  const calcolaSconto = (totaleLordo) => {
    if (!scontoAttivo) return null;
    if (tipoSconto === "percento") {
      const pct = Math.min(scontoNum, 100);
      const imp = Math.round(totaleLordo * pct / 100);
      return { importo: imp, etichetta: `-${pct}% (-${imp}€)` };
    }
    const imp = Math.min(Math.round(scontoNum), totaleLordo);
    return { importo: imp, etichetta: `-${imp}€` };
  };

  // Totale lordo di una specifica opzione
  const calcolaTotale = (opt) => {
    const pA   = getPrezzoAdulto(opt) + (nataleEff && periodoEff==="alta" ? L.natale : 0) + (capodannoEff && periodoEff==="alta" ? L.capodanno : 0);
    const p512 = prezzoBimbi512 + (capodannoEff && periodoEff==="alta" ? L.capodanno_b512 : 0);
    return pA * adulti + prezzoBimbi24 * b24 + p512 * b512 + costoDieta;
  };

  const optUI            = modalitaBassa === "senza" ? "senza" : "con";
  const prezzoAdultoUI   = getPrezzoAdulto(optUI) + (nataleEff && periodoEff==="alta" ? L.natale : 0) + (capodannoEff && periodoEff==="alta" ? L.capodanno : 0);
  const prezzoBimbi512UI = prezzoBimbi512 + (capodannoEff && periodoEff==="alta" ? L.capodanno_b512 : 0);
  const totAdultiUI      = prezzoAdultoUI * adulti;
  const totB24UI         = prezzoBimbi24 * b24;
  const totB512UI        = prezzoBimbi512UI * b512;
  const totPersone       = adulti + b02 + b24 + b512;
  const nDietaEff        = dieta ? Math.min(Math.max(1, nDieta), totPersone) : 0;
  const costoDieta       = nDietaEff * SUPPL_DIETA;
  const totaleUI         = totAdultiUI + totB24UI + totB512UI + costoDieta;
  // Nel riepilogo UI lo sconto si vede solo se riguarda l'opzione mostrata (A o opzione singola)
  const scontoValeUI     = !(periodoEff === "bassa" && modalitaBassa === "senza");
  const scontoUI         = scontoValeUI ? calcolaSconto(totaleUI) : null;
  const totaleScontatoUI = scontoUI ? totaleUI - scontoUI.importo : totaleUI;

  const getRigaEsc = (opt) => {
    if (periodoEff === "alta") return nottiEff > 7 ? t.escAltaLunga : t.escAltaCorte;
    if (opt === "con")         return nottiEff > 7 ? t.escBassaConLunga : t.escBassaConCorte;
    return t.escBassaSenza.replace("80€", `${L.esc_full}€`).replace("40€", `${L.esc_half}€`);
  };

  const getRigaFestivita = () => {
    if (periodoEff !== "alta") return "";
    if (!nataleEff && !capodannoEff) return festivitaRilevante ? `\n${t.avvisoEsclusi} ${t.esclusoNatale}, ${t.esclusoCapodanno}` : "";
    const inc = [];
    if (nataleEff)    inc.push(t.natale);
    if (capodannoEff) inc.push(t.capodanno);
    return "\n" + inc.join("\n");
  };

  // Periodo nel messaggio: solo data / mese / intervallo, senza riferimenti a stagione
  const getPeriodoLabel = () => {
    if (!periodoEff) return "";
    if (modoPeriodo === "mese" && mese !== "") return nomeMese(Number(mese), lingua);
    if (modoPeriodo === "date" && checkIn && checkOut && !dataErrore) {
      return t.dalAl(fmtData(checkIn, lingua), fmtData(checkOut, lingua));
    }
    return t.periodi[periodoEff] || "";
  };

  // Link PDF: alta → solo Completo; bassa → Completo + Flessibile
  const bloccoPdf = () => {
    if (!periodoEff) return "";
    const righe = [`${t.pdfCompleto} → ${PDF.full}`];
    if (periodoEff === "bassa") righe.push(`${t.pdfFlessibile} → ${PDF.flex}`);
    return `\n\n${t.pdfIntro}\n${righe.join("\n")}`;
  };

  const bloccoSocial = () =>
`${t.seguici}
${t.socialBluFb} → ${SOCIAL.blufb}
${t.socialBluIg} → ${SOCIAL.bluig}
${t.socialBluSito} → ${SOCIAL.blusito}
${t.socialA20Fb} → ${SOCIAL.a20fb}
${t.socialA20Ig} → ${SOCIAL.a20ig}
${t.socialA20Sito} → ${SOCIAL.a20sito}`;

  const rigaBimbi = (p512f) => {
    let r = "";
    if (b02  > 0) r += `\n👶 ${t.bimbi02} (${b02}): *${t.gratuito}*`;
    if (b24  > 0) r += `\n👶 ${t.bimbi24} (${b24}): *${prezzoBimbi24}€/cad* → ${t.totale}: *${prezzoBimbi24*b24}€*`;
    if (b512 > 0) r += `\n👦 ${t.bimbi512} (${b512}): *${p512f}€/cad* → ${t.totale}: *${p512f*b512}€*`;
    if (nDietaEff > 0) r += `\n🌾 ${t.dieta} (${nDietaEff}): *${SUPPL_DIETA}€/cad* → ${t.totale}: *${costoDieta}€*`;
    return r;
  };

  const notaDietaScript = nDietaEff > 0 ? `${t.notaDieta}\n\n` : "";

  // Blocco totale + sconto. "sconta" decide se lo sconto si applica a questa opzione.
  const bloccoTotale = (tot, sconta) => {
    const sc = sconta ? calcolaSconto(tot) : null;
    if (!sc) return `💰 *${t.totaleComplessivo}: ${tot}€*`;
    return `💰 *${t.totaleComplessivo}: ${tot}€*
${t.scontoRiga} ${sc.etichetta}
${t.totaleScontato}: *${tot - sc.importo}€*`;
  };

  const bloccoOpzione = (opt, sconta) => {
    const pA   = getPrezzoAdulto(opt) + (nataleEff && periodoEff==="alta" ? L.natale : 0) + (capodannoEff && periodoEff==="alta" ? L.capodanno : 0);
    const p512 = prezzoBimbi512 + (capodannoEff && periodoEff==="alta" ? L.capodanno_b512 : 0);
    const tA   = pA * adulti;
    const tB24 = prezzoBimbi24 * b24;
    const tB512= p512 * b512;
    const tot  = tA + tB24 + tB512 + costoDieta;
    const rigaEsc = getRigaEsc(opt);
    return `👤 ${t.adulti} (${adulti}${isSingle && adulti===1 ? ` — ${t.singola}` : ""}): *${pA}€/cad* → ${t.totale}: *${tA}€*${rigaBimbi(p512)}

${bloccoTotale(tot, sconta)}
_(${t.voliEsclusi})_${rigaEsc ? `\n_${rigaEsc}_` : ""}`;
  };

  // Riquadro di confronto rapido fra le due opzioni (solo bassa + entrambe)
  const bloccoConfronto = () => {
    const totA = calcolaTotale("con");
    const totB = calcolaTotale("senza");
    const scA  = calcolaSconto(totA);
    const rigaA = scA
      ? `${t.optAbreve}: ~${totA}€~ → *${totA - scA.importo}€* (${t.conSconto})`
      : `${t.optAbreve}: *${totA}€*`;
    return `${t.confrontoTitolo}
${rigaA}
${t.optBbreve}: *${totB}€*
_(${t.voliEsclusi})_`;
  };

  const generaScript = () => {
    if (!periodoEff || idx < 0) return "";
    const n            = nome || "[Nome]";
    const periodoLabel = getPeriodoLabel();
    const social       = bloccoSocial();
    const pdf          = bloccoPdf();

    if (periodoEff === "bassa" && modalitaBassa === "entrambe") {
      return `${t.saluto(n)}

${t.proposta(periodoLabel)}

🗓️ *${giorni} ${t.giorni} / ${nottiEff} ${t.notti}*

${bloccoConfronto()}

─────────────────────

${t.optA}
${bloccoOpzione("con", true)}

─────────────────────

${t.optB}
${bloccoOpzione("senza", false)}

${notaDietaScript}⚠️ *N.B.: LE ESCURSIONI NON SONO RIMBORSABILI PER VS NO-SHOW O PER METEO AVVERSO*

${t.inclusoDoppio}
${t.servizi.map(s=>`• ${s}`).join("\n")}${pdf}

📖 ${t.recensioni}
⭐ Google Reviews → ${GOOGLE}
⭐ TripAdvisor → ${TRIP}

${social}

${t.voli}

${t.chiudi}`;
    }

    const opt  = periodoEff === "bassa" ? modalitaBassa : "alta";
    const pA   = getPrezzoAdulto(opt) + (nataleEff && periodoEff==="alta" ? L.natale : 0) + (capodannoEff && periodoEff==="alta" ? L.capodanno : 0);
    const p512 = prezzoBimbi512 + (capodannoEff && periodoEff==="alta" ? L.capodanno_b512 : 0);
    const tA   = pA * adulti;
    const tB24 = prezzoBimbi24 * b24;
    const tB512= p512 * b512;
    const tot  = tA + tB24 + tB512 + costoDieta;
    const fest = getRigaFestivita();
    const rigaEsc = getRigaEsc(opt);
    // Opzione singola: lo sconto si applica tranne che sulla "solo senza escursioni"
    const sconta = !(periodoEff === "bassa" && modalitaBassa === "senza");

    return `${t.saluto(n)}

${t.proposta(periodoLabel)}

🗓️ *${giorni} ${t.giorni} / ${nottiEff} ${t.notti}*
👤 ${t.adulti} (${adulti}${isSingle && adulti===1 ? ` — ${t.singola}` : ""}): *${pA}€/cad* → ${t.totale}: *${tA}€*${rigaBimbi(p512)}

${bloccoTotale(tot, sconta)}
_(${t.voliEsclusi})_${fest}${rigaEsc ? `\n\n_${rigaEsc}_` : ""}

${notaDietaScript}⚠️ *N.B.: LE ESCURSIONI NON SONO RIMBORSABILI PER VS NO-SHOW O PER METEO AVVERSO*

${t.incluso}
${t.servizi.map(s=>`• ${s}`).join("\n")}${pdf}

📖 ${t.recensioni}
⭐ Google Reviews → ${GOOGLE}
⭐ TripAdvisor → ${TRIP}

${social}

${t.voli}

${t.chiudi}`;
  };

  const script = generaScript();
  const copia = () => {
    navigator.clipboard.writeText(script).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const inputCls = "w-full border border-blue-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white";
  const labelCls = "block text-xs font-semibold text-blue-900 mb-1";

  const Toggle = ({ val, set }) => (
    <div onClick={() => set(!val)} className={`w-11 h-6 rounded-full transition-all relative cursor-pointer ${val ? "bg-amber-500" : "bg-gray-200"}`}>
      <div className={`absolute top-1 w-4 h-4 rounded-full bg-white shadow transition-all ${val ? "left-6" : "left-1"}`} />
    </div>
  );

  return (
    <div className="rounded-2xl bg-gradient-to-br from-slate-100 to-blue-50 p-4" data-testid="quote-calculator">
      <div className="max-w-2xl mx-auto">

        <div className="bg-gradient-to-r from-slate-700 to-blue-700 rounded-2xl p-5 mb-5 text-white text-center shadow-lg">
          <div className="text-2xl mb-1">🔐 Blu Lodge Maldives</div>
          <div className="text-sm opacity-90">Generatore Preventivo — Uso interno</div>
        </div>

        <div className="bg-white rounded-2xl shadow-md p-5 mb-5 space-y-4">

          <div>
            <label className={labelCls}>🌐 Lingua del preventivo</label>
            <div className="flex flex-wrap gap-2">
              {Object.entries(traduzioni).map(([k,v]) => (
                <button key={k} onClick={() => setLingua(k)}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium border transition-all ${lingua===k ? "bg-blue-600 text-white border-blue-600" : "bg-white text-blue-700 border-blue-300 hover:bg-blue-50"}`}>
                  {v.flag} {v.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className={labelCls}>👤 Nome del cliente</label>
            <input className={inputCls} placeholder="Es. Marco" value={nome} onChange={e => setNome(e.target.value)} />
          </div>

          <div>
            <label className={labelCls}>📅 Periodo di soggiorno</label>
            <div className="flex rounded-xl overflow-hidden border border-blue-300 text-sm font-medium mb-3">
              {[
                { val:"stagione", label:"🌴 Stagione" },
                { val:"mese",     label:"🗓️ Mese" },
                { val:"date",     label:"📅 Date precise" },
              ].map(opt => (
                <button key={opt.val} onClick={() => cambiaModo(opt.val)}
                  className={`flex-1 py-2 px-1 text-center transition-all text-xs ${modoPeriodo===opt.val ? "bg-blue-600 text-white" : "bg-white text-blue-700 hover:bg-blue-50"}`}>
                  {opt.label}
                </button>
              ))}
            </div>

            {modoPeriodo === "stagione" && (
              <select className={inputCls} value={periodo} onChange={e => { setPeriodo(e.target.value); setNatale(false); setCapodanno(false); setModalitaBassa("entrambe"); }}>
                <option value="">— Seleziona —</option>
                <option value="alta">🌴 Novembre – Aprile (Alta Stagione)</option>
                <option value="bassa">☀️ Luglio – Ottobre (Bassa Stagione)</option>
              </select>
            )}

            {modoPeriodo === "mese" && (
              <>
                <select className={inputCls} value={mese} onChange={e => { setMese(e.target.value); setNatale(false); setCapodanno(false); setModalitaBassa("entrambe"); }}>
                  <option value="">— Seleziona il mese —</option>
                  {MESI_STANDARD.map(m => (
                    <option key={m} value={m}>
                      {stagioneDaMese(m) === "alta" ? "🌴" : "☀️"} {nomeMese(m, "it")} ({stagioneDaMese(m) === "alta" ? "Alta" : "Bassa"} Stagione)
                    </option>
                  ))}
                  {forzaChiusura && MESI_CHIUSURA.map(m => (
                    <option key={m} value={m}>
                      ⚠️ {nomeMese(m, "it")} (chiusura forzata — listino Bassa)
                    </option>
                  ))}
                </select>
                <div className="mt-2 text-xs text-gray-500">ℹ️ Struttura chiusa dal 10 maggio al 30 giugno. Per l'1–9 maggio (listino Alta) usa le date precise.</div>
              </>
            )}

            {modoPeriodo === "date" && (
              <>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className={labelCls}>Check-in</label>
                    <input type="date" className={inputCls} value={checkIn}
                      onChange={e => applyCheckIn(e.target.value)} />
                    <input type="text" inputMode="numeric" placeholder="gg/mm/aaaa"
                      className={`${inputCls} mt-1 text-xs`}
                      value={checkInTxt}
                      onChange={e => {
                        setCheckInTxt(e.target.value);
                        const iso = txtToIso(e.target.value);
                        if (iso) applyCheckIn(iso);
                      }} />
                  </div>
                  <div>
                    <label className={labelCls}>Check-out</label>
                    <input type="date" className={inputCls} value={checkOut} min={checkIn || undefined}
                      onChange={e => applyCheckOut(e.target.value)} />
                    <input type="text" inputMode="numeric" placeholder="gg/mm/aaaa"
                      className={`${inputCls} mt-1 text-xs`}
                      value={checkOutTxt}
                      onChange={e => {
                        setCheckOutTxt(e.target.value);
                        const iso = txtToIso(e.target.value);
                        if (iso) applyCheckOut(iso);
                      }} />
                  </div>
                </div>
                <div className="mt-1 text-xs text-gray-500">
                  💡 Se il calendario non risponde (modalità PC su tablet), scrivi la data nel campo testo sotto.
                </div>

                {dataErrore === "ordine" && (
                  <div className="mt-2 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                    ⚠️ Il check-out deve essere successivo al check-in.
                  </div>
                )}
                {dataErrore === "chiuso" && (
                  <div className="mt-2 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                    ⚠️ La struttura è chiusa dal 10 maggio al 30 giugno: il soggiorno selezionato non è vendibile. Se vuoi comunque emettere il preventivo, attiva "Forza prenotazione" qui sotto.
                  </div>
                )}
                {dataErrore === "durata" && (
                  <div className="mt-2 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                    ⚠️ Durata fuori listino: il prezziario copre soggiorni da 5 a 15 notti (selezionate: {nottiDate}).
                  </div>
                )}

                {checkIn && checkOut && checkOut > checkIn && <QuoteAvailability checkIn={checkIn} checkOut={checkOut} />}
                {checkIn && checkOut && !dataErrore && (
                  <div className="mt-2 text-xs text-blue-800 bg-blue-50 border border-blue-200 rounded-lg px-3 py-2 space-y-1">
                    <div>✅ <b>{nottiDate} notti / {nottiDate + 1} giorni</b> — {periodoEff === "alta" ? "🌴 Alta Stagione" : "☀️ Bassa Stagione"}</div>
                    {toccaChiusura && <div className="text-orange-700">⚠️ Il soggiorno cade (in tutto o in parte) nel periodo di chiusura 10 maggio – 30 giugno: prenotazione forzata.</div>}
                    {nataleAuto && <div>🎄 Il soggiorno include il 24 dicembre: cena di Natale aggiunta automaticamente (+{L.natale}€/adulto)</div>}
                    {capodannoAuto && <div>🎆 Il soggiorno include il 31 dicembre: cenone di Capodanno aggiunto automaticamente (+{L.capodanno}€/adulto, +{L.capodanno_b512}€ bimbi 5-12,99)</div>}
                  </div>
                )}
              </>
            )}

            {(modoPeriodo === "mese" || modoPeriodo === "date") && (
              <div className="mt-3 flex items-center justify-between bg-orange-50 border border-orange-200 rounded-xl px-3 py-2">
                <div className="text-xs text-orange-800">
                  <b>⚠️ Forza prenotazione in chiusura</b>
                  <div className="text-orange-600">10 maggio – 30 giugno · listino Bassa Stagione</div>
                </div>
                <Toggle val={forzaChiusura} set={cambiaForza} />
              </div>
            )}
          </div>

          {periodoEff === "bassa" && (
            <div className="bg-cyan-50 rounded-xl p-4 border border-cyan-200">
              <div className="text-xs font-semibold text-cyan-800 mb-3">🤿 Modalità preventivo bassa stagione</div>
              <div className="flex rounded-xl overflow-hidden border border-cyan-300 text-sm font-medium">
                {[
                  { val:"entrambe", label:"📋 Mostra entrambe" },
                  { val:"con",      label:"🤿 Solo con escursioni" },
                  { val:"senza",    label:"🏖️ Solo senza escursioni" },
                ].map(opt => (
                  <button key={opt.val} onClick={() => setModalitaBassa(opt.val)}
                    className={`flex-1 py-2 px-1 text-center transition-all text-xs ${modalitaBassa===opt.val ? "bg-cyan-600 text-white" : "bg-white text-cyan-700 hover:bg-cyan-50"}`}>
                    {opt.label}
                  </button>
                ))}
              </div>
              {modalitaBassa === "entrambe" && (
                <div className="mt-2 text-xs text-cyan-700 bg-cyan-100 rounded-lg px-3 py-2">
                  💡 Lo script apre con il confronto dei due totali, poi elenca le opzioni nel dettaglio.
                </div>
              )}
            </div>
          )}

          {modoPeriodo !== "date" && (
            <div>
              <label className={labelCls}>🗓️ Numero di notti: <span className="text-blue-600 font-bold">{notti} notti / {notti + 1} giorni</span></label>
              <input type="range" min={5} max={15} value={notti} onChange={e => setNotti(Number(e.target.value))} className="w-full accent-blue-500" />
              <div className="flex justify-between text-xs text-gray-400 mt-1">
                {nottiList.map(n => <span key={n}>{n}</span>)}
              </div>
            </div>
          )}

          <div>
            <label className={labelCls}>👥 Numero adulti</label>
            <div className="flex items-center gap-3">
              <button onClick={() => { setAdulti(Math.max(1, adulti-1)); setIsSingle(false); }} className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 font-bold text-lg">−</button>
              <span className="text-lg font-bold text-blue-800 w-6 text-center">{adulti}</span>
              <button onClick={() => { setAdulti(adulti+1); setIsSingle(false); }} className="w-8 h-8 rounded-full bg-blue-100 text-blue-700 font-bold text-lg">+</button>
              {adulti === 1 && (
                <label className="flex items-center gap-2 text-sm text-blue-700 ml-2 cursor-pointer">
                  <input type="checkbox" checked={isSingle} onChange={e => setIsSingle(e.target.checked)} className="accent-blue-500" />
                  Supplemento singola (+{L.singola_pct}%)
                </label>
              )}
            </div>
          </div>

          <div className="bg-blue-50 rounded-xl p-3 space-y-3">
            <div className="text-xs font-semibold text-blue-900">👶 Bambini</div>
            {[
              { label:"0-1,99 anni (gratuito)", val:b02, set:setB02 },
              { label:"2-4,99 anni", val:b24, set:setB24 },
              { label:"5-12,99 anni", val:b512, set:setB512 },
            ].map(r => (
              <div key={r.label} className="flex items-center justify-between">
                <span className="text-xs text-blue-800">{r.label}</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => r.set(Math.max(0, r.val-1))} className="w-7 h-7 rounded-full bg-white border border-blue-200 text-blue-700 font-bold">−</button>
                  <span className="w-5 text-center text-sm font-bold text-blue-800">{r.val}</span>
                  <button onClick={() => r.set(r.val+1)} className="w-7 h-7 rounded-full bg-white border border-blue-200 text-blue-700 font-bold">+</button>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-green-50 rounded-xl p-3 space-y-3 border border-green-200">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-sm text-green-900 font-medium">🌾 Celiachia / allergie / intolleranze alimentari</div>
                <div className="text-xs text-green-700">+{SUPPL_DIETA}€ a persona interessata</div>
              </div>
              <Toggle val={dieta} set={(v) => { setDieta(v); if (v) setNDieta(1); }} />
            </div>
            {dieta && (
              <>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-green-800">Persone con esigenze alimentari</span>
                  <div className="flex items-center gap-2">
                    <button onClick={() => setNDieta(Math.max(1, nDietaEff-1))} className="w-7 h-7 rounded-full bg-white border border-green-300 text-green-700 font-bold">−</button>
                    <span className="w-5 text-center text-sm font-bold text-green-800">{nDietaEff}</span>
                    <button onClick={() => setNDieta(Math.min(totPersone, nDietaEff+1))} className="w-7 h-7 rounded-full bg-white border border-green-300 text-green-700 font-bold">+</button>
                  </div>
                </div>
                <div className="text-xs text-green-700 bg-green-100 rounded-lg px-3 py-2">
                  ℹ️ Nel preventivo verrà aggiunta la nota su non contaminazione e prodotti senza glutine anche importati dall'Italia.
                </div>
              </>
            )}
          </div>

          {periodoEff === "alta" && (modoPeriodo === "stagione" || (modoPeriodo === "mese" && Number(mese) === 11)) && (
            <div className="bg-amber-50 rounded-xl p-3 space-y-3 border border-amber-100">
              <div className="text-xs font-semibold text-amber-800">🎄 Festività (opzionale)</div>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm text-amber-900 font-medium">🎄 Cena di Natale</div>
                  <div className="text-xs text-amber-600">{L.natale}€/adulto</div>
                </div>
                <Toggle val={natale} set={setNatale} />
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-sm text-amber-900 font-medium">🎆 Cenone di Capodanno</div>
                  <div className="text-xs text-amber-600">{L.capodanno}€/adulto · {L.capodanno_b512}€ bimbi 5-12,99</div>
                </div>
                <Toggle val={capodanno} set={setCapodanno} />
              </div>
            </div>
          )}

          {periodoEff === "alta" && modoPeriodo === "date" && (nataleAuto || capodannoAuto) && (
            <div className="bg-amber-50 rounded-xl p-3 space-y-1 border border-amber-100">
              <div className="text-xs font-semibold text-amber-800">🎄 Festività incluse automaticamente in base alle date</div>
              {nataleAuto && <div className="text-sm text-amber-900">🎄 Cena di Natale — {L.natale}€/adulto</div>}
              {capodannoAuto && <div className="text-sm text-amber-900">🎆 Cenone di Capodanno — {L.capodanno}€/adulto · {L.capodanno_b512}€ bimbi 5-12,99</div>}
            </div>
          )}
        </div>

        {periodoEff && (
          <div className="bg-white rounded-2xl shadow-md p-5 mb-5">
            <div className="text-sm font-bold text-blue-900 mb-3">
              💰 Riepilogo costi {periodoEff === "bassa" && modalitaBassa === "entrambe" ? <span className="text-cyan-600 font-normal">(Opzione A — con escursioni)</span> : ""}
            </div>
            <div className="space-y-1 text-sm">
              <div className="flex justify-between">
                <span>👤 Adulti ({adulti}{isSingle && adulti===1 ? " singola" : ""}) × {prezzoAdultoUI}€</span>
                <span className="font-semibold">{totAdultiUI}€</span>
              </div>
              {b02  > 0 && <div className="flex justify-between text-green-600"><span>👶 Bimbi 0-1,99 ({b02})</span><span className="font-semibold">GRATIS</span></div>}
              {b24  > 0 && <div className="flex justify-between"><span>👶 Bimbi 2-4,99 ({b24}) × {prezzoBimbi24}€</span><span className="font-semibold">{totB24UI}€</span></div>}
              {b512 > 0 && <div className="flex justify-between"><span>👦 Bimbi 5-12,99 ({b512}) × {prezzoBimbi512UI}€</span><span className="font-semibold">{totB512UI}€</span></div>}
              {nDietaEff > 0 && <div className="flex justify-between text-green-700"><span>🌾 Celiachia/allergie ({nDietaEff}) × {SUPPL_DIETA}€</span><span className="font-semibold">{costoDieta}€</span></div>}
              <div className="border-t pt-2 mt-2 flex justify-between text-base font-bold text-blue-700">
                <span>TOTALE (voli esclusi)</span><span>{totaleUI}€</span>
              </div>
              {scontoUI && (
                <>
                  <div className="flex justify-between text-rose-600 font-semibold">
                    <span>🎁 Sconto applicato</span><span>{scontoUI.etichetta}</span>
                  </div>
                  <div className="flex justify-between text-base font-bold text-green-700">
                    <span>TOTALE SCONTATO</span><span>{totaleScontatoUI}€</span>
                  </div>
                </>
              )}
              {periodoEff === "bassa" && modalitaBassa === "entrambe" && (
                <div className="flex justify-between text-gray-500 pt-2 border-t mt-2">
                  <span>🏖️ Opzione B (senza escursioni)</span>
                  <span className="font-semibold">{calcolaTotale("senza")}€</span>
                </div>
              )}
            </div>

            {/* Sconto */}
            <div className="mt-4 pt-4 border-t bg-rose-50 -mx-5 -mb-5 px-5 py-4 rounded-b-2xl">
              <div className="text-xs font-semibold text-rose-800 mb-2">🎁 Scontistica (opzionale)</div>
              <div className="flex rounded-xl overflow-hidden border border-rose-300 text-sm font-medium mb-2">
                {[
                  { val:"nessuno",  label:"Nessuno" },
                  { val:"euro",     label:"Cifra €" },
                  { val:"percento", label:"Percentuale %" },
                ].map(opt => (
                  <button key={opt.val} onClick={() => { setTipoSconto(opt.val); if (opt.val === "nessuno") setValoreSconto(""); }}
                    className={`flex-1 py-2 px-1 text-center transition-all text-xs ${tipoSconto===opt.val ? "bg-rose-600 text-white" : "bg-white text-rose-700 hover:bg-rose-100"}`}>
                    {opt.label}
                  </button>
                ))}
              </div>
              {tipoSconto !== "nessuno" && (
                <div className="flex items-center gap-2">
                  <input type="number" min="0" step="1"
                    className="w-full border border-rose-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-rose-400 bg-white"
                    placeholder={tipoSconto === "euro" ? "Es. 150" : "Es. 10"}
                    value={valoreSconto}
                    onChange={e => setValoreSconto(e.target.value)} />
                  <span className="text-sm font-bold text-rose-700">{tipoSconto === "euro" ? "€" : "%"}</span>
                </div>
              )}
              {scontoAttivo && periodoEff === "bassa" && (
                <div className="mt-2 text-xs text-rose-700">
                  💡 In bassa stagione lo sconto si applica solo all'Opzione A (con escursioni).
                </div>
              )}
            </div>
          </div>
        )}

        {script && (
          <div className="bg-white rounded-2xl shadow-md p-5">
            <div className="flex justify-between items-center mb-3">
              <div className="text-sm font-bold text-blue-900">📱 Script WhatsApp — {t.flag} {t.label}</div>
              <button data-testid="quote-copy" onClick={copia} className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all ${copied ? "bg-green-500 text-white" : "bg-blue-600 text-white hover:bg-blue-700"}`}>
                {copied ? "✅ Copiato!" : "📋 Copia"}
              </button>
            </div>
            <pre data-testid="quote-script" className="text-xs text-gray-700 whitespace-pre-wrap bg-gray-50 rounded-xl p-4 leading-relaxed">{script}</pre>
            <QuoteActions quote={{
              client_name: nome, lingua, checkin: modoPeriodo === "date" ? checkIn : "", checkout: modoPeriodo === "date" ? checkOut : "",
              periodo_label: getPeriodoLabel(), stagione: periodoEff, notti: nottiEff, adulti, bambini: b02 + b24 + b512,
              totale: periodoEff === "bassa" && modalitaBassa === "entrambe" ? calcolaTotale("con") : totaleUI,
              totale_scontato: scontoUI ? totaleScontatoUI : null, listino: L.name, script,
            }} />
          </div>
        )}

        {!periodoEff && (
          <div className="text-center text-blue-400 text-sm py-4">
            👆 Seleziona il periodo (stagione, mese o date) per generare il preventivo
          </div>
        )}
      </div>
    </div>
  );
}
